import { IconProps } from '../icon';

export function SuiviInstructionIcon(props: IconProps) {
  return (
    <svg
      id="Suivie_d_instruction"
      data-name="Suivie d’instruction"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="40"
      height="18.707"
      viewBox="0 0 40 18.707"
      {...props}
    >
      <defs>
        <clipPath id="clipPath">
          <rect
            id="Rectangle_337"
            data-name="Rectangle 337"
            width="40"
            height="18.707"
            fill="none"
          />
        </clipPath>
        <clipPath id="clipPath-3">
          <rect
            id="Rectangle_329"
            data-name="Rectangle 329"
            width="9.769"
            height="1.131"
            fill="none"
          />
        </clipPath>
        <clipPath id="clipPath-4">
          <rect
            id="Rectangle_330"
            data-name="Rectangle 330"
            width="8.194"
            height="1.171"
            fill="none"
          />
        </clipPath>
        <clipPath id="clipPath-5">
          <rect
            id="Rectangle_331"
            data-name="Rectangle 331"
            width="5.154"
            height="1.172"
            fill="none"
          />
        </clipPath>
        <clipPath id="clipPath-6">
          <rect
            id="Rectangle_332"
            data-name="Rectangle 332"
            width="3.566"
            height="1.131"
            fill="none"
          />
        </clipPath>
        <clipPath id="clipPath-7">
          <rect
            id="Rectangle_333"
            data-name="Rectangle 333"
            width="2.318"
            height="1.165"
            fill="none"
          />
        </clipPath>
        <clipPath id="clipPath-8">
          <rect
            id="Rectangle_334"
            data-name="Rectangle 334"
            width="2.299"
            height="1.12"
            fill="none"
          />
        </clipPath>
        <clipPath id="clipPath-9">
          <rect
            id="Rectangle_335"
            data-name="Rectangle 335"
            width="30.207"
            height="13.127"
            fill="none"
          />
        </clipPath>
      </defs>
      <g id="Groupe_633" data-name="Groupe 633" clipPath="url(#clipPath)">
        <g id="Groupe_632" data-name="Groupe 632">
          <g id="Groupe_631" data-name="Groupe 631" clipPath="url(#clipPath)">
            <path
              id="Tracé_248"
              data-name="Tracé 248"
              d="M24.241,106.929v0h.391c.411,0,.758-.134.751-.594-.006-.41-.333-.559-.71-.565-.338-.005-.678-.009-1.015.018s-.607.182-.592.582.287.525.629.553c.181.015.365,0,.547,0m1.6,5.393h-.533c-.357,0-.637.114-.651.518-.016.442.267.591.662.6.158,0,.316.008.474,0,.475-.025,1.167.158,1.163-.567s-.71-.5-1.115-.548"
              transform="translate(-21.506 -98.619)"
              fill="#f7f6f6"
            />
            <path
              id="Tracé_249"
              data-name="Tracé 249"
              d="M173.1,140.164a1.518,1.518,0,0,1-1.519,1.518c-.157.014-.317.006-.475.006q-13.093,0-26.189,0a4.024,4.024,0,0,1-.862-.079,1.335,1.335,0,0,1-1.15-1.394c-.006-.764.016-1.527.025-2.291l.092-.06c2.78-1.8,5.477-4.121,8.251-5.961l.581.369c.808.51,1.587,1,2.3,1.454a1.838,1.838,0,0,0,.17.111l.046.027c1.456.927,2.578,1.651,2.975,1.926l.087.062a1.071,1.071,0,0,0,1.41-.008l.391-.255.093-.06.2-.127q2.037-1.328,4.086-2.638c.136-.087.429-.271.722-.453.024-.013.046-.027.068-.041l.006,0,0,0c2.362,1.559,4.715,3.129,7.088,4.669a3.851,3.851,0,0,0,1.567.859q0,.086,0,.171c.021.732.07,1.465.035,2.194"
              transform="translate(-133.243 -122.984)"
              fill="#92b72e"
            />
            <path
              id="Tracé_250"
              data-name="Tracé 250"
              d="M467.817,55.778q0,5.354,0,10.709c-.044-.006-.089-.013-.131-.022a4.482,4.482,0,0,1-1.435-.838c-2.33-1.513-4.9-3.235-7.227-4.773,3.29-2.1,7.1-4.529,8.718-5.559l.131-.084c.027.189-.079.379-.052.567"
              transform="translate(-427.993 -51.479)"
              fill="#92b72e"
            />
            <path
              id="Tracé_251"
              data-name="Tracé 251"
              d="M153.354,61c-2.844,1.855-5.971,4.018-8.788,5.846-.014-.086-.029-.17-.044-.253l-.01-.054V65.411q0-.974,0-1.95c0-.39,0-.781,0-1.171V60.037c0-.39,0-.781,0-1.171q0-.977,0-1.95V55.785c.019-.106.036-.211.054-.317l.1.06.111.07.06.038c1.3.822,4.765,2.994,7.938,5l.581.369"
              transform="translate(-134.744 -51.719)"
              fill="#92b72e"
            />
            <g
              id="Groupe_612"
              data-name="Groupe 612"
              transform="translate(0 4.066)"
              opacity="0.4"
            >
              <g id="Groupe_611" data-name="Groupe 611">
                <g
                  id="Groupe_610"
                  data-name="Groupe 610"
                  clipPath="url(#clipPath-3)"
                >
                  <path
                    id="Tracé_252"
                    data-name="Tracé 252"
                    d="M9.769,60.147q0,.566,0,1.131L1.221,61.27c-.185,0-.369,0-.554,0-.354,0-.653-.108-.666-.508-.014-.426.27-.6.667-.606.9-.006,1.794,0,2.691,0l6.41,0"
                    transform="translate(-0.001 -60.147)"
                    fill="#92b72e"
                  />
                </g>
              </g>
            </g>
            <g
              id="Groupe_615"
              data-name="Groupe 615"
              transform="translate(1.577 10.571)"
              opacity="0.4"
            >
              <g id="Groupe_614" data-name="Groupe 614">
                <g
                  id="Groupe_613"
                  data-name="Groupe 613"
                  clipPath="url(#clipPath-4)"
                >
                  <path
                    id="Tracé_253"
                    data-name="Tracé 253"
                    d="M31.52,156.389q0,.586,0,1.171-3.468,0-6.936,0a5.072,5.072,0,0,1-.784-.046.512.512,0,0,1-.474-.537.538.538,0,0,1,.472-.548,2.993,2.993,0,0,1,.627-.032q3.547,0,7.094-.006"
                    transform="translate(-23.328 -156.389)"
                    fill="#92b72e"
                  />
                </g>
              </g>
            </g>
            <g
              id="Groupe_618"
              data-name="Groupe 618"
              transform="translate(4.618 7.146)"
              opacity="0.4"
            >
              <g id="Groupe_617" data-name="Groupe 617">
                <g
                  id="Groupe_616"
                  data-name="Groupe 616"
                  clipPath="url(#clipPath-5)"
                >
                  <path
                    id="Tracé_254"
                    data-name="Tracé 254"
                    d="M73.47,105.727q0,.585,0,1.171c-1.42,0-2.84-.006-4.259,0-.452,0-.915-.05-.891-.623.021-.524.489-.542.894-.543,1.42,0,2.839,0,4.259,0"
                    transform="translate(-68.316 -105.726)"
                    fill="#92b72e"
                  />
                </g>
              </g>
            </g>
            <g
              id="Groupe_621"
              data-name="Groupe 621"
              transform="translate(6.203 13.692)"
              opacity="0.4"
            >
              <g id="Groupe_620" data-name="Groupe 620">
                <g
                  id="Groupe_619"
                  data-name="Groupe 619"
                  clipPath="url(#clipPath-6)"
                >
                  <path
                    id="Tracé_255"
                    data-name="Tracé 255"
                    d="M95.332,202.562v1.131c-.942,0-1.883-.005-2.824,0-.416,0-.762-.135-.74-.6.02-.418.358-.521.74-.519.941,0,1.883,0,2.824-.007"
                    transform="translate(-91.767 -202.562)"
                    fill="#92b72e"
                  />
                </g>
              </g>
            </g>
            <g
              id="Groupe_624"
              data-name="Groupe 624"
              transform="translate(1.559 7.149)"
              opacity="0.4"
            >
              <g id="Groupe_623" data-name="Groupe 623">
                <g
                  id="Groupe_622"
                  data-name="Groupe 622"
                  clipPath="url(#clipPath-7)"
                >
                  <path
                    id="Tracé_256"
                    data-name="Tracé 256"
                    d="M24.241,106.928c-.182,0-.366.012-.547,0-.342-.028-.614-.158-.629-.553s.248-.554.593-.582.676-.024,1.015-.018c.377.006.7.155.71.565.007.46-.34.6-.751.594h-.391v0"
                    transform="translate(-23.065 -105.768)"
                    fill="#92b72e"
                  />
                </g>
              </g>
            </g>
            <g
              id="Groupe_627"
              data-name="Groupe 627"
              transform="translate(3.147 13.701)"
              opacity="0.4"
            >
              <g id="Groupe_626" data-name="Groupe 626">
                <g
                  id="Groupe_625"
                  data-name="Groupe 625"
                  clipPath="url(#clipPath-8)"
                >
                  <path
                    id="Tracé_257"
                    data-name="Tracé 257"
                    d="M47.749,202.7c.4.046,1.11-.188,1.115.548s-.688.542-1.163.567c-.157.008-.316,0-.474,0-.395-.005-.678-.154-.662-.6.015-.4.295-.52.651-.518h.533"
                    transform="translate(-46.564 -202.694)"
                    fill="#92b72e"
                  />
                </g>
              </g>
            </g>
            <g
              id="Groupe_630"
              data-name="Groupe 630"
              transform="translate(9.793)"
              opacity="0.8"
            >
              <g id="Groupe_629" data-name="Groupe 629">
                <g
                  id="Groupe_628"
                  data-name="Groupe 628"
                  clipPath="url(#clipPath-9)"
                >
                  <path
                    id="Tracé_258"
                    data-name="Tracé 258"
                    d="M144.9,3.751c-.01-.738-.038-1.475-.026-2.213a1.4,1.4,0,0,1,1.315-1.5A5.176,5.176,0,0,1,146.983,0q12.946,0,25.891,0c1.774,0,2.21.43,2.209,2.186,0,.421-.019.843-.029,1.264l-.1.283c-2.678,1.707-12.7,8.089-14.283,9.124a1.07,1.07,0,0,1-1.41.009c-.994-.729-12.447-7.908-14.36-9.115"
                    transform="translate(-144.876 -0.001)"
                    fill="#92b72e"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default SuiviInstructionIcon;
